import React from 'react';
import {StandingsWidgetContent} from "./standings-widget-content";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {WidgetWrapper} from "../../../core/components/misc/widget-wrapper/widget-wrapper";
import {StandingsWidgetController} from "../standings-widget.controller";

export class StandingsWidgetCollapsedProps extends BaseProps {
  controller: StandingsWidgetController;
  isPreviewStandings: Boolean;
  source: String;
}

export const StandingsWidgetCollapsed = ({
                                           controller,
                                           source,
                                           isPreviewStandings,
                                           collapsedCompetitorIds
                                         }: StandingsWidgetCollapsedProps) => {
  const {state} = controller;
  const {collapsedTitle} = state;

  const baseProps = {
    source,
    controller,
    isPreviewStandings,
    collapsedCompetitorIds
  }

  const wrapperCardProps = {
    controller,
    title: collapsedTitle
  }

  return (
    <WidgetWrapper {...wrapperCardProps}>
      <StandingsWidgetContent {...baseProps}/>
    </WidgetWrapper>
  )
};
